// Bilingual content store. FR is complete, EN is partial (key sections translated).
export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      heritage: 'Héritage',
      collections: 'Collections',
      boutique: 'Boutique',
      b2b: 'Espace Pro',
      contact: 'Contact',
    },
    common: {
      since: 'Depuis 1977',
      tagline: 'Exprime ton Style',
      discoverHeritage: 'Découvrir l’héritage',
      discoverCollections: 'Voir les collections',
      visitBoutique: 'Visiter la boutique',
      contactUs: 'Nous écrire',
      learnMore: 'En savoir plus',
      becomePartner: 'Devenir partenaire',
      sending: 'Envoi…',
      submit: 'Envoyer',
      back: 'Retour à l’accueil',
      required: 'Champ requis',
    },
    home: {
      heroEyebrow: 'Polynésie française · Since 1977',
      heroTitle: 'Exprime ton Style.',
      heroSub:
        "L'élégance du Pacifique, entre héritage polynésien et modernité — une marque née à Tahiti il y a près de cinquante ans.",
      heritageEyebrow: 'Notre histoire',
      heritageTitle: 'Près de cinquante ans d’élégance insulaire.',
      heritageBody:
        'Fondée à Papeete en 1977 par Enio et Marina Chiocchi, Tahitian Move est devenue un repère de la mode polynésienne contemporaine. Du prêt-à-porter aux savates iconiques, chaque pièce porte l’empreinte d’un savoir-faire transmis depuis presque cinq décennies.',
      collectionsEyebrow: 'Collections',
      collectionsTitle: 'Une garde-robe pensée pour le rythme du Pacifique.',
      collectionsBody:
        'Du prêt-à-porter aux accessoires lifestyle, en passant par notre chaussant signature, chaque collection raconte une part de notre île.',
      boutiqueEyebrow: 'Boutique Papeete',
      boutiqueTitle: 'Venez vivre la marque à Tahiti.',
      boutiqueBody:
        'Découvrez l’ensemble de nos collections dans notre boutique historique au cœur de Papeete. Une expérience à part entière, entre patrimoine et nouveautés.',
      b2bEyebrow: 'Espace Pro',
      b2bTitle: 'Distribuez une marque chargée d’histoire.',
      b2bBody:
        'Distributeurs, revendeurs ou presse — découvrez les opportunités de collaboration avec une marque polynésienne installée depuis 1977.',
      newsletterTitle: 'Restez en mouvement.',
      newsletterBody: 'Inscrivez-vous pour suivre nos nouveautés et collections capsules.',
      newsletterPlaceholder: 'Votre adresse email',
      newsletterCta: 'S’inscrire',
    },
    heritage: {
      title: 'Héritage',
      subtitle: 'Une histoire polynésienne, depuis 1977.',
      sections: [
        {
          year: '1977',
          title: 'Les origines',
          body:
            "Enio et Marina Chiocchi fondent Tahitian Move à Papeete. Une vision : habiller la Polynésie de pièces élégantes, intemporelles et résolument insulaires.",
        },
        {
          year: '1980 – 2000',
          title: 'L’essor d’une marque identitaire',
          body:
            "Les collections se déploient : prêt-à-porter, savates emblématiques aux brides turquoise, accessoires. Tahitian Move devient un nom familier des Polynésiens.",
        },
        {
          year: '2000 – 2020',
          title: 'Modernité & savoir-faire',
          body:
            "La marque conjugue héritage et renouveau. Les coupes s’affinent, les matières se travaillent, l’ADN polynésien reste intact.",
        },
        {
          year: 'Aujourd’hui',
          title: 'Une marque tournée vers l’export',
          body:
            "Forte de près de cinquante ans d’histoire, Tahitian Move déploie son univers au-delà du Pacifique, à la rencontre de partenaires et d’amateurs de mode insulaire à travers le monde.",
        },
      ],
      valuesTitle: 'Nos valeurs',
      values: [
        {
          title: 'Authenticité',
          body: 'Une marque née à Tahiti, qui n’a jamais quitté son île.',
        },
        {
          title: 'Élégance',
          body: 'Des pièces pensées pour durer, ni clichés, ni tendances éphémères.',
        },
        {
          title: 'Transmission',
          body: 'Un savoir-faire porté depuis 1977, génération après génération.',
        },
      ],
    },
    collections: {
      title: 'Collections',
      subtitle: 'Quatre univers, une seule marque.',
      intro:
        'Tahitian Move décline son écriture stylistique à travers quatre univers complémentaires. Aucun prix n’est affiché : pour toute information ou disponibilité, rendez-vous en boutique.',
      categories: [
        {
          key: 'femme',
          title: 'Femme',
          body: 'Robes fluides, hauts brodés, tenues estivales — une féminité solaire.',
        },
        {
          key: 'homme',
          title: 'Homme',
          body: 'Chemises légères, polos, shorts et pièces décontractées au caractère affirmé.',
        },
        {
          key: 'chaussant',
          title: 'Chaussant',
          body: 'Nos savates iconiques aux brides turquoise, sandales et nu-pieds signature.',
        },
        {
          key: 'accessoires',
          title: 'Accessoires',
          body: 'Sacs, chapeaux, bijoux et accessoires lifestyle pour compléter le style.',
        },
      ],
      noPriceNote: 'Pas de vente en ligne — rendez-vous en boutique pour découvrir les collections.',
    },
    boutique: {
      title: 'Boutique',
      subtitle: 'Venez nous rencontrer à Papeete.',
      addressLabel: 'Adresse',
      addressLines: ['Tahitian Move — SARL Blue Star', 'Fare Ute, Papeete', 'Polynésie française'],
      hoursLabel: 'Horaires',
      hoursLines: [
        'Lundi – Vendredi : 08h00 – 16h00',
        'Samedi : 08h00 – 12h00',
        'Dimanche : fermé',
      ],
      contactLabel: 'Contact',
      phone: '+689 40 50 23 00',
      email: 'contact@tahitianmove.com',
      directionsCta: 'Itinéraire',
      noteLabel: 'Bon à savoir',
      note:
        "L’ensemble des collections — prêt-à-porter Femme & Homme, chaussant et accessoires — est exposé en boutique. Nos conseillères vous accompagnent dans votre choix.",
    },
    b2b: {
      title: 'Espace Pro',
      subtitle: 'Distributeurs · Revendeurs · Presse',
      intro:
        "Vous représentez un point de vente, une centrale d’achat, un acteur de la presse mode ou un projet de distribution à l’international ? Tahitian Move, marque polynésienne installée depuis 1977, étudie chaque demande avec attention.",
      whyTitle: 'Pourquoi Tahitian Move',
      why: [
        { title: 'Une marque installée', body: 'Près de 50 ans d’existence, une notoriété forte en Polynésie française.' },
        { title: 'Une identité unique', body: 'Une écriture stylistique mêlant héritage polynésien et élégance moderne.' },
        { title: 'Une démarche pro', body: 'Catalogues, fiches produits et conditions partenaires sur demande.' },
      ],
      formTitle: 'Devenir un distributeur de nos marques & de nos produits',
      formIntro: 'Vous souhaitez devenir distributeur ou revendeur de Tahitian Move ? Renseignez les informations ci-dessous pour recevoir notre catalogue professionnel et entrer en contact avec notre équipe. Tous les champs sont obligatoires.',
      fields: {
        company: 'Nom de l’enseigne',
        contactName: 'Prénom & Nom',
        tahitiNumber: 'N° TAHITI',
        phone: 'N° de téléphone',
        email: 'Adresse email',
        address: 'Adresse géographique',
        type: 'Type d’activité',
        message: 'Message complémentaire (optionnel)',
      },
      types: {
        distributor: 'Distributeur',
        retailer: 'Revendeur',
      },
      success: 'Merci, votre demande nous est bien parvenue. Nous reviendrons vers vous rapidement avec notre catalogue professionnel.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Une question ? Écrivez-nous.',
      intro: 'Pour toute information générale, suggestion ou demande presse particulière, contactez-nous.',
      fields: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone (optionnel)',
        subject: 'Sujet',
        message: 'Votre message',
      },
      success: 'Merci, votre message nous est bien parvenue. À très vite.',
      proNotice: 'Vous êtes un professionnel ? Utilisez plutôt notre',
      proLink: 'Espace Pro',
    },
    footer: {
      tagline: 'Exprime ton Style',
      since: 'Marque polynésienne depuis 1977',
      explore: 'Explorer',
      brand: 'La marque',
      legal: 'Mentions légales',
      privacy: 'Confidentialité',
      cookies: 'Cookies',
      rights: 'Tous droits réservés.',
      company: 'SARL Blue Star · Fare Ute, Papeete, Polynésie française',
    },
    legal: {
      title: 'Mentions légales',
      editor: 'Éditeur du site',
      editorBody: 'SARL Blue Star · N° TAHITI 080283 · R.C.S 8250B\nSiège social : Fare Ute, Papeete, Polynésie française\nTéléphone : +689 40 50 23 00\nEmail : contact@tahitianmove.com',
      director: 'Directrice de la publication',
      directorBody: 'Loana Chiocchi',
      hosting: 'Hébergement',
      hostingBody: 'Site hébergé sur infrastructure Emergent.\nLes coordonnées de l’hébergeur peuvent être communiquées sur simple demande.',
      ip: 'Propriété intellectuelle',
      ipBody:
        "L’ensemble des contenus présents sur ce site (textes, images, logo, identité graphique « Tahitian Move ») est la propriété exclusive de la SARL Blue Star. Toute reproduction, totale ou partielle, sans autorisation écrite préalable est interdite.\n\nMarques déposées :\n• TAHITIAN MOVE — N°3610213, date de dépôt : 07/11/2008, I.N.P.I. PARIS\n• TAHITI SINCE 1977 — N°3600551, date de dépôt : 24/09/2008, I.N.P.I. PARIS",
      data: 'Données personnelles',
      dataBody:
        "Les informations collectées via les formulaires (contact, espace pro) sont uniquement destinées à un usage interne et à la gestion des demandes. Vous pouvez exercer vos droits d’accès, de modification et de suppression en écrivant à contact@tahitianmove.com.",
    },
    admin: {
      loginTitle: 'Espace administrateur',
      email: 'Email',
      password: 'Mot de passe',
      login: 'Connexion',
      logout: 'Déconnexion',
      dashboardTitle: 'Tableau de bord',
      contactsTab: 'Messages',
      b2bTab: 'Demandes B2B',
      statsTab: 'Statistiques',
      noData: 'Aucune entrée pour le moment.',
      markRead: 'Marquer lu',
      archive: 'Archiver',
      reopen: 'Rouvrir',
    },
  },
  en: {
    nav: {
      home: 'Home',
      heritage: 'Heritage',
      collections: 'Collections',
      boutique: 'Boutique',
      b2b: 'Trade',
      contact: 'Contact',
    },
    common: {
      since: 'Since 1977',
      tagline: 'Express Your Style',
      discoverHeritage: 'Discover the heritage',
      discoverCollections: 'View collections',
      visitBoutique: 'Visit the boutique',
      contactUs: 'Get in touch',
      learnMore: 'Learn more',
      becomePartner: 'Become a partner',
      sending: 'Sending…',
      submit: 'Send',
      back: 'Back to home',
      required: 'Required',
    },
    home: {
      heroEyebrow: 'French Polynesia · Since 1977',
      heroTitle: 'Express Your Style.',
      heroSub:
        'Pacific elegance — where Polynesian heritage meets modernity. A brand born in Tahiti almost fifty years ago.',
      heritageEyebrow: 'Our story',
      heritageTitle: 'Nearly fifty years of island elegance.',
      heritageBody:
        'Founded in Papeete in 1977 by Enio and Marina Chiocchi, Tahitian Move has become a landmark of contemporary Polynesian fashion. From ready-to-wear to our iconic sandals, every piece carries the imprint of a craft passed down for almost five decades.',
      collectionsEyebrow: 'Collections',
      collectionsTitle: 'A wardrobe built for the rhythm of the Pacific.',
      collectionsBody:
        'From ready-to-wear to lifestyle accessories — and our signature footwear — each collection tells a part of our island.',
      boutiqueEyebrow: 'Papeete boutique',
      boutiqueTitle: 'Experience the brand in Tahiti.',
      boutiqueBody:
        'Discover all our collections at our historic boutique in the heart of Papeete.',
      b2bEyebrow: 'Trade',
      b2bTitle: 'Distribute a brand with history.',
      b2bBody:
        'Distributors, retailers, press — discover the collaboration opportunities with a Polynesian brand established since 1977.',
      newsletterTitle: 'Stay in motion.',
      newsletterBody: 'Subscribe to follow our drops and capsule collections.',
      newsletterPlaceholder: 'Your email address',
      newsletterCta: 'Subscribe',
    },
    heritage: {
      title: 'Heritage',
      subtitle: 'A Polynesian story since 1977.',
      sections: [
        { year: '1977', title: 'The origins', body: 'Enio and Marina Chiocchi found Tahitian Move in Papeete with a single vision: dress Polynesia in elegant, timeless and resolutely island pieces.' },
        { year: '1980 – 2000', title: 'The rise of an identity', body: 'Collections grow: ready-to-wear, our iconic turquoise-strap sandals, and accessories. Tahitian Move becomes a household name.' },
        { year: '2000 – 2020', title: 'Modernity & craft', body: 'The brand blends heritage and renewal. Cuts refine, fabrics evolve, the Polynesian DNA remains.' },
        { year: 'Today', title: 'A brand reaching the world', body: 'After nearly fifty years, Tahitian Move expands beyond the Pacific to meet partners and fashion lovers worldwide.' },
      ],
      valuesTitle: 'Our values',
      values: [
        { title: 'Authenticity', body: 'A brand born in Tahiti — that never left its island.' },
        { title: 'Elegance', body: 'Pieces made to last, free from clichés or fast trends.' },
        { title: 'Transmission', body: 'A craft carried since 1977, generation after generation.' },
      ],
    },
    collections: {
      title: 'Collections',
      subtitle: 'Four universes, one brand.',
      intro: 'Tahitian Move expresses its style through four complementary universes. No prices shown — for any information or availability, please visit the boutique.',
      categories: [
        { key: 'femme', title: 'Women', body: 'Flowing dresses, embroidered tops, summer outfits — a radiant femininity.' },
        { key: 'homme', title: 'Men', body: 'Light shirts, polos, shorts and laid-back pieces with character.' },
        { key: 'chaussant', title: 'Footwear', body: 'Our iconic turquoise-strap sandals, signature slides and beach shoes.' },
        { key: 'accessoires', title: 'Accessories', body: 'Bags, hats, jewellery and lifestyle accessories to complete the look.' },
      ],
      noPriceNote: 'No online sales — visit the boutique to discover the collections.',
    },
    boutique: {
      title: 'Boutique',
      subtitle: 'Come meet us in Papeete.',
      addressLabel: 'Address',
      addressLines: ['Tahitian Move — SARL Blue Star', 'Fare Ute, Papeete', 'French Polynesia'],
      hoursLabel: 'Opening hours',
      hoursLines: [
        'Monday – Friday: 8:00 AM – 4:00 PM',
        'Saturday: 8:00 AM – 12:00 PM',
        'Sunday: closed',
      ],
      contactLabel: 'Contact',
      phone: '+689 40 50 23 00',
      email: 'contact@tahitianmove.com',
      directionsCta: 'Get directions',
      noteLabel: 'Good to know',
      note: 'All our collections — Women & Men ready-to-wear, footwear and accessories — are on display. Our team is here to advise you.',
    },
    b2b: {
      title: 'Trade',
      subtitle: 'Distributors · Retailers · Press',
      intro: 'You represent a store, a buying group, a fashion media outlet or an international distribution project? Tahitian Move, a Polynesian brand established since 1977, reviews every inquiry carefully.',
      whyTitle: 'Why Tahitian Move',
      why: [
        { title: 'An established brand', body: 'Nearly 50 years, with strong recognition across French Polynesia.' },
        { title: 'A unique identity', body: 'A style blending Polynesian heritage and modern elegance.' },
        { title: 'A professional process', body: 'Catalogues, product sheets and partner terms available on request.' },
      ],
      formTitle: 'Become a distributor of our brands & products',
      formIntro: 'Want to become a distributor or retailer of Tahitian Move? Fill in the information below to receive our professional catalog and get in touch with our team. All fields are required.',
      fields: {
        company: 'Company / Store name',
        contactName: 'First & Last name',
        tahitiNumber: 'TAHITI Number',
        phone: 'Phone number',
        email: 'Email address',
        address: 'Geographic address',
        type: 'Business type',
        message: 'Additional message (optional)',
      },
      types: {
        distributor: 'Distributor',
        retailer: 'Retailer',
      },
      success: 'Thank you, we received your inquiry. We will be in touch shortly with our professional catalog.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'A question? Write to us.',
      intro: 'For any general information, suggestion or specific press inquiry, get in touch.',
      fields: {
        name: 'Full name',
        email: 'Email',
        phone: 'Phone (optional)',
        subject: 'Subject',
        message: 'Your message',
      },
      success: 'Thank you, your message has been received. Talk soon.',
      proNotice: 'You are a professional? Please use our',
      proLink: 'Trade',
    },
    footer: {
      tagline: 'Express Your Style',
      since: 'Polynesian brand since 1977',
      explore: 'Explore',
      brand: 'Brand',
      legal: 'Legal notice',
      privacy: 'Privacy',
      cookies: 'Cookies',
      rights: 'All rights reserved.',
      company: 'SARL Blue Star · Fare Ute, Papeete, French Polynesia',
    },
    legal: {
      title: 'Legal notice',
      editor: 'Site publisher',
      editorBody: 'SARL Blue Star · N° TAHITI 080283 · R.C.S 8250B\nHead office: Fare Ute, Papeete, French Polynesia\nPhone: +689 40 50 23 00\nEmail: contact@tahitianmove.com',
      director: 'Publication director',
      directorBody: 'Loana Chiocchi',
      hosting: 'Hosting',
      hostingBody: 'This site is hosted on Emergent infrastructure.\nHosting provider details can be shared upon request.',
      ip: 'Intellectual property',
      ipBody:
        'All content on this site (text, images, logo, "Tahitian Move" identity) is the exclusive property of SARL Blue Star. Any reproduction, in whole or in part, without prior written consent is prohibited.\n\nRegistered trademarks:\n• TAHITIAN MOVE — No.3610213, filed on 07/11/2008, I.N.P.I. PARIS\n• TAHITI SINCE 1977 — No.3600551, filed on 24/09/2008, I.N.P.I. PARIS',
      data: 'Personal data',
      dataBody:
        'Information collected via the contact and trade forms is only used internally to handle your inquiry. You may exercise your rights of access, modification and deletion by writing to contact@tahitianmove.com.',
    },
    admin: {
      loginTitle: 'Admin area',
      email: 'Email',
      password: 'Password',
      login: 'Log in',
      logout: 'Log out',
      dashboardTitle: 'Dashboard',
      contactsTab: 'Messages',
      b2bTab: 'B2B inquiries',
      statsTab: 'Statistics',
      noData: 'No entries yet.',
      markRead: 'Mark read',
      archive: 'Archive',
      reopen: 'Reopen',
    },
  },
};
